"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = exports.setOpacity = void 0;

var _this = void 0,
    _arguments = arguments;

var setOpacity = function setOpacity(hex, alpha) {
  var value = hex.replace('#', '');
  var r = parseInt(value.substring(0, 2), 16);
  var g = parseInt(value.substring(2, 4), 16);
  var b = parseInt(value.substring(4, 6), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
};

exports.setOpacity = setOpacity;

var debounce = function debounce(fn) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var timeout;
  return function () {
    var functionCall = function functionCall() {
      return fn.apply(_this, _arguments);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

exports.debounce = debounce;